import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-left-tail', 'ArrowLeftTail', [["path",{"d":"M18 12h-15"}],["path",{"d":"M6 9l-3 3l3 3"}],["path",{"d":"M21 9l-3 3l3 3"}]]);